/**
 * Storage key constants for SecureStorageWebCrypto
 */
export const SECURE_STORAGE_KEYS = {
    /** Prefix for sync entity status keys */
    SYNC_ENTITY: 'SyncEntity_',

    /** Individual data keys */
    LIKES: 'UserMediaLike_',
    COMMENT_LIKES: 'CommentLike_',
    COMMUNITY_MESSAGE_LIKES: 'CommunityMessageLike_',
    SAVED_CONTENT: 'SavedContent_',
    SAVED_USERS: 'SavedUser_',
    BLOCKED_USERS: 'BlockedUser_',
    MUTED_USERS: 'MutedUser_',
    USERS_BLOCKED_ME: 'UserBlockedMe_',
    BLOCKED_CONVERSATIONS: 'BlockedConversation_',
    WALLET: 'Wallet',
    DEVICE_ID: 'DeviceId',
    EXCLUSIVE_SUBSCRIPTIONS: 'ExclusiveContentSubscription_',
    USER_SETTINGS: 'UserSetting_',
    USER_PREMIUM_PACKAGES: 'UserPremiumPackage_',
    PREMIUM_PACKAGES: 'PremiumPackages_',
    GIFTS: 'Gift_',
    RECHARGE_PRODUCTS: 'RechargeWalletProduct_',
    ROADMAP_LIKES: 'RoadmapItemLike_',
    ROADMAP_COMMENT_LIKES: 'RoadmapCommentLike_',
    DONATION_PRODUCTS: 'DonationProduct_',
    FAVOURITE_HASHTAGS: 'FavouriteHashTag_',
    UNLOCKED_CONTENT: 'UnlockedContent_',
    PRIVATE_JWK: 'PrivateJwk_',
    CURRENT_USER: 'CurrentUser_',

    /** Prefix for user-media items currently being processed by the transcode cloud function */
    PENDING_PROCESSING_MEDIA: 'PendingProcessingMedia_',
} as const;